module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header filled full-block light"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "inline-block"
  }, [_vm._v(_vm._s(_vm.deal.deal_title))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goDeal(_vm.deal.deal_token)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-bag"
  }), _vm._v(" 銷售管理")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default active",
    on: {
      "click": function($event) {
        _vm.goDealManagement(_vm.deal.deal_token)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(" 專案管理")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goDealFinance(_vm.deal.deal_token)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign"
  }), _vm._v(" 帳款管理")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "product_drag_container"
  }, [(_vm.project.project_lists.length == 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 mt-5 pt-5 text-center"
  }, [_c('h2', [_vm._v("此專案目前沒有任何工作項目")]), _vm._v(" "), _c('p', [_vm._v("你可以手動建立工作項目，或從已儲存的範本匯入工作項目")]), _vm._v(" "), (_vm.list_loading) ? _c('button', {
    staticClass: "btn btn-default disable text-left"
  }, [_vm._m(0)]) : _c('button', {
    staticClass: "btn btn-default text-left ",
    on: {
      "click": function($event) {
        _vm.addNewList()
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default text-left",
    on: {
      "click": function($event) {
        _vm.showImportTemplateModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-file-import"
  }), _vm._v(" 從範本匯入")])])]) : _vm._e(), _vm._v(" "), _c('Container', {
    attrs: {
      "orientation": "horizontal",
      "drag-handle-selector": ".column-drag-handle",
      "drop-placeholder": _vm.upperDropPlaceholderOptions
    },
    on: {
      "drop": function($event) {
        _vm.onColumnDrop($event)
      },
      "drag-start": _vm.dragStart
    }
  }, [_vm._l((_vm.project.project_lists), function(column) {
    return _c('Draggable', {
      key: column.id
    }, [_c('div', {
      staticClass: "project-card-container"
    }, [_c('div', {
      staticClass: "project-card-column-header column-drag-handle"
    }, [_c('div', {
      staticClass: "project-card-title"
    }, [(_vm.canEditColumn('column_name', column.id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (column.name),
        expression: "column.name"
      }],
      ref: ('column_name' + column.id),
      refInFor: true,
      staticClass: "form-control",
      domProps: {
        "value": (column.name)
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.target.blur()
        },
        "blur": function($event) {
          _vm.finishedEditColumn();
          _vm.updateProjectList(column)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          column.name = $event.target.value
        }
      }
    }) : _c('div', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.editColumn('column_name', column.id)
        }
      }
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-body"
    }, [(column.name != '' && column.name != null) ? _c('span', [_vm._v(_vm._s(column.name))]) : _c('span', {
      staticClass: "text-gray"
    }, [_vm._v("新列表")])]), _vm._v(" "), (column.owners) ? _c('div', {
      staticStyle: {
        "width": "40px"
      },
      on: {
        "click": function($event) {
          _vm.editOwner(column)
        }
      }
    }, _vm._l((column.owners), function(u, index) {
      return (index < 2) ? _c('img', {
        staticClass: "avatar-size avatar-size-xs project-avatar",
        style: ('right:' + 10 * index + 'px'),
        attrs: {
          "src": u.avatar || '/static/avatar-default.jpg'
        }
      }) : _vm._e()
    })) : _vm._e()])]), _vm._v(" "), (column.start_at && column.end_at) ? _c('div', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.editWorkDay(column)
        }
      }
    }, [_c('h6', {
      staticClass: "m-0"
    }, [_c('small', [_vm._v(_vm._s(_vm._f("moment_date")(column.start_at, "")) + " ~ " + _vm._s(_vm._f("moment_date")(column.end_at, "")) + " "), _c('span', {
      staticClass: "ml-2"
    }, [_vm._v(_vm._s(column.work_days + 1) + "工作天")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "dropdown pull-right"
    }, [_c('button', {
      staticClass: "btn btn-default btn-more btn-sm",
      attrs: {
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [_c('i', {
      staticClass: "fas fa-caret-down"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu pointer",
      attrs: {
        "aria-labelledby": "about-us"
      }
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editOwner(column)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" 指派負責人")])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editWorkDay(column)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" 制定工作日期")])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.temp_list = column;
          _vm.temp_list.delete_alert = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" 刪除列表")])])])])]), _vm._v(" "), _c('div', {
      ref: ('project-card-box' + column.id),
      refInFor: true,
      staticClass: "project-card-box"
    }, [_c('Container', {
      attrs: {
        "group-name": "col",
        "get-child-payload": _vm.getCardPayload(column.id),
        "drag-class": "project-card-ghost",
        "drop-class": "project-card-ghost-drop",
        "drop-placeholder": _vm.dropPlaceholderOptions
      },
      on: {
        "drop": function (e) { return _vm.onCardDrop(column.id, e); },
        "drag-start": function (e) { return _vm.log('drag start', e); },
        "drag-end": function (e) { return _vm.log('drag end', e); }
      }
    }, [_vm._l((column.project_cards), function(card) {
      return _c('Draggable', {
        key: card.id
      }, [_c('div', {
        staticClass: "project-card",
        class: card.label
      }, [_c('div', {
        staticClass: "card-title",
        class: {
          'has-checkbox': card.project_card_lists.length == 0
        }
      }, [(card.project_card_lists.length == 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (card.is_done),
          expression: "card.is_done"
        }],
        staticClass: "input-success pointer",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(card.is_done) ? _vm._i(card.is_done, null) > -1 : (card.is_done)
        },
        on: {
          "change": function($event) {
            _vm.updateCard(card)
          },
          "__c": function($event) {
            var $$a = card.is_done,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (card.is_done = $$a.concat([$$v]))
              } else {
                $$i > -1 && (card.is_done = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              card.is_done = $$c
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (card.name != '') ? _c('p', {
        staticClass: "margin-0 pointer",
        on: {
          "click": function($event) {
            _vm.showCard(card)
          }
        }
      }, [_vm._v(_vm._s(card.name))]) : _c('p', {
        staticClass: "margin-0 pointer text-gray",
        on: {
          "click": function($event) {
            _vm.showCard(card)
          }
        }
      }, [_vm._v("新卡片")])]), _vm._v(" "), _c('div', {
        staticClass: "project-card-info pointer",
        on: {
          "click": function($event) {
            _vm.showCard(card)
          }
        }
      }, [_c('div', {
        staticClass: "item-info"
      }, [(card.project_card_lists.length > 0) ? _c('span', {
        staticClass: "mr-3",
        class: {
          'btn btn-success btn-xs': _vm.doneItemsFromCards(card.project_card_lists) == _vm.totalItemsFromCards(card.project_card_lists)
        }
      }, [_c('i', {
        staticClass: "fa fa-list"
      }), _vm._v(" " + _vm._s(_vm.doneItemsFromCards(card.project_card_lists)) + "/" + _vm._s(_vm.totalItemsFromCards(card.project_card_lists)) + "\n                        ")]) : _vm._e(), _vm._v(" "), (card.project_card_comments.length != 0) ? _c('span', {
        staticClass: "mr-3"
      }, [_c('i', {
        staticClass: "far fa-comment-alt"
      }), _vm._v(" " + _vm._s(card.project_card_comments.length) + "\n                        ")]) : _vm._e()])])])])
    }), _vm._v(" "), (_vm.add_new_card == column.id) ? _c('div', {
      staticClass: "project-card"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.temp_card.name),
        expression: "temp_card.name"
      }],
      ref: ('new_card_input' + column.id),
      refInFor: true,
      staticClass: "form-control no-border-input",
      attrs: {
        "type": "input",
        "placeholder": "請為這個卡片增加標題"
      },
      domProps: {
        "value": (_vm.temp_card.name)
      },
      on: {
        "keydown": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.addNewCard(column.id)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
          _vm.resetTempCard()
        }],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.temp_card.name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-sm",
      on: {
        "click": function($event) {
          _vm.addNewCard(column.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-white btn-sm",
      on: {
        "click": function($event) {
          _vm.add_new_card = ''
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "text-center add_new_card pointer",
      on: {
        "click": function($event) {
          _vm.add_new_card = column.id;
          _vm.editColumn('new_card_input', column.id);
          _vm.scrollBottom('project-card-box', column.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" 新增卡片")])])])
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px",
      "display": "inline-block"
    }
  })], 2), _vm._v(" "), (_vm.showCardModal) ? _c('div', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showCardModal = false;
        _vm.resetTempCard()
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.showCardModal = false;
        _vm.resetTempCard()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "min-height": "0px"
    }
  }, [_c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showCardModal = false;
        _vm.resetTempCard()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body row j-forms card-show-content",
    staticStyle: {
      "padding": "0 0 10px 0",
      "max-height": "85vh"
    }
  }, [_c('div', {
    staticClass: "card-main-area col-md-9"
  }, [(_vm.canEditColumn('card_name', _vm.temp_card.id)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_card.name),
      expression: "temp_card.name"
    }],
    ref: ('card_name' + _vm.temp_card.id),
    staticClass: "form-control",
    domProps: {
      "value": (_vm.temp_card.name)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "blur": function($event) {
        _vm.updateCard(_vm.temp_card)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_card.name = $event.target.value
      }
    }
  }) : _c('h4', {
    staticClass: "pointer bold500",
    on: {
      "click": function($event) {
        _vm.editColumn('card_name', _vm.temp_card.id)
      }
    }
  }, [(_vm.temp_card.name != '') ? _c('span', [_vm._v(_vm._s(_vm.temp_card.name))]) : _c('span', {
    staticClass: "text-gray"
  }, [_vm._v("新卡片")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {}, [(_vm.canEditColumn('card_description', _vm.temp_card.id)) ? _c('textarea', {
    directives: [{
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.temp_card.description),
      expression: "temp_card.description"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_card.description),
      expression: "  temp_card.description"
    }],
    ref: ('card_description' + _vm.temp_card.id),
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.temp_card.description)
    },
    on: {
      "blur": function($event) {
        _vm.updateCard(_vm.temp_card)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_card.description = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(_vm.temp_card.description) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.canEditColumn('card_description', _vm.temp_card.id) == false && _vm.temp_card.description != '') ? _c('div', {
    staticClass: "pre well well-sm pointer text-gray",
    on: {
      "click": function($event) {
        _vm.editColumn('card_description', _vm.temp_card.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.temp_card.description))]) : _vm._e(), _vm._v(" "), (_vm.canEditColumn('card_description', _vm.temp_card.id) == false && _vm.temp_card.description == '') ? _c('div', {
    staticClass: "pre well well-sm pointer text-gray",
    on: {
      "click": function($event) {
        _vm.editColumn('card_description', _vm.temp_card.id)
      }
    }
  }, [_vm._v("你可以為這張卡片加上詳細的描述...")]) : _vm._e()]), _vm._v(" "), (_vm.temp_card.project_card_lists.length != 0) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('Container', {
    attrs: {
      "lock-axis": "y",
      "drop-placeholder": _vm.dropPlaceholderOptions
    },
    on: {
      "drop": function($event) {
        _vm.onListDrop($event)
      }
    }
  }, _vm._l((_vm.temp_card.project_card_lists), function(list) {
    return _c('Draggable', {
      key: list.id,
      staticClass: "item-lists"
    }, [(_vm.canEditColumn('list_content', list.id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.content),
        expression: "list.content"
      }],
      ref: ('list_content' + list.id),
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "margin-bottom": "5px"
      },
      domProps: {
        "value": (list.content)
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.target.blur()
        },
        "blur": function($event) {
          _vm.updateCardList(list)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          list.content = $event.target.value
        }
      }
    }) : _c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-body"
    }, [_c('h5', {
      staticClass: "pointer bold500",
      on: {
        "click": function($event) {
          _vm.temp_card_list = list;
          _vm.editColumn('list_content', list.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-list"
    }), _vm._v(" "), (list.content == '' || list.content == null) ? _c('span', [_vm._v("新分類名稱")]) : _c('span', [_vm._v(_vm._s(list.content))])])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default align-self-center btn-xs mr-1",
      on: {
        "click": function($event) {
          _vm.deleteProjectCardList(list)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar progress-bar-success",
      style: ('width:' + _vm.doneItems(list.project_card_list_items).length * 100 / list.project_card_list_items.length + '%'),
      attrs: {
        "role": "progressbar",
        "aria-valuenow": "70",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }
    }, [_c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(_vm.doneItems(list.project_card_list_items) * 100 / list.project_card_list_items.length) + "% Complete")])])]), _vm._v(" "), _c('div', {
      staticClass: "item-list"
    }, [_c('Container', {
      attrs: {
        "group-name": "item",
        "get-child-payload": _vm.getItemPayload(list.id),
        "lock-axis": "y",
        "drop-placeholder": _vm.dropItemPlaceholderOptions
      },
      on: {
        "drop": function (e) { return _vm.onItemDrop(list.id, e); },
        "drag-start": function (e) { return _vm.log('drag start', e); },
        "drag-end": function (e) { return _vm.log('drag end', e); }
      }
    }, _vm._l((list.project_card_list_items), function(item) {
      return _c('Draggable', {
        key: item.id,
        staticClass: "single-item"
      }, [_c('div', {
        staticClass: "media-left"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.is_done),
          expression: "item.is_done"
        }],
        staticClass: "input-success pointer",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(item.is_done) ? _vm._i(item.is_done, null) > -1 : (item.is_done)
        },
        on: {
          "change": function($event) {
            _vm.updateCardListItem(item)
          },
          "__c": function($event) {
            var $$a = item.is_done,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (item.is_done = $$a.concat([$$v]))
              } else {
                $$i > -1 && (item.is_done = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              item.is_done = $$c
            }
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "media-body"
      }, [(_vm.canEditColumn('item_content', item.id)) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.content),
          expression: "item.content"
        }],
        ref: ('item_content' + item.id),
        refInFor: true,
        staticClass: "form-control",
        domProps: {
          "value": (item.content)
        },
        on: {
          "keydown": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
            $event.target.blur()
          },
          "blur": function($event) {
            _vm.updateCardListItem(item)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.content = $event.target.value
          }
        }
      }) : _c('p', {
        staticClass: "pointer relative pr-5"
      }, [(item.content == null) ? _c('span', {
        staticClass: "btn-block",
        on: {
          "click": function($event) {
            _vm.editColumn('item_content', item.id)
          }
        }
      }, [_vm._v("新項目")]) : _c('span', {
        staticClass: "btn-block",
        on: {
          "click": function($event) {
            _vm.editColumn('item_content', item.id)
          }
        }
      }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-default btn-xs",
        staticStyle: {
          "right": "2px",
          "top": "2px",
          "position": "absolute"
        },
        on: {
          "click": function($event) {
            _vm.deleteListItem(list, item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times"
      })])])])])
    })), _vm._v(" "), (list.loading != true) ? _c('button', {
      staticClass: "btn btn-gray",
      staticStyle: {
        "margin-top": "5px"
      },
      on: {
        "click": function($event) {
          _vm.addNewCardListItem(list)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" 增加項目")]) : _c('button', {
      staticClass: "btn btn-gray",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('i', {
      staticClass: "fas fa-spinner"
    }), _vm._v(" 項目建立中")])], 1)])
  }))], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_c('i', {
    staticClass: "far fa-comment-alt"
  }), _vm._v(" 留言 (" + _vm._s(_vm.temp_card.project_card_comments.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "card-comment-textarea media"
  }, [_c('img', {
    staticClass: "avatar-size",
    attrs: {
      "src": _vm.user.profile_pic || '/static/avatar-default.jpg'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_comment.content),
      expression: "temp_comment.content"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "你可以在此留言..."
    },
    domProps: {
      "value": (_vm.temp_comment.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_comment.content = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(_vm.temp_comment.content))]), _vm._v(" "), (_vm.temp_comment.loading) ? _c('button', {
    staticClass: "btn btn-default disabled",
    staticStyle: {
      "margin": "10px 0px"
    }
  }, [_vm._v("\n                        建立中..\n                      ")]) : _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "10px 0px"
    },
    on: {
      "click": function($event) {
        _vm.addNewComment()
      }
    }
  }, [_vm._v("\n                        新增留言\n                      ")])])]), _vm._v(" "), _vm._l((_vm.temp_card.project_card_comments), function(comment) {
    return _c('div', {
      staticClass: "single-card-comment"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('img', {
      staticClass: "avatar-size",
      attrs: {
        "src": comment.user_avatar || '/static/avatar-default.jpg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('div', {
      staticClass: "card-message-box"
    }, [_vm._v(_vm._s(comment.content)), _c('br'), _c('small', [_vm._v(_vm._s(_vm._f("moment")(comment.created_at, "dddd, MMMM Do YYYY")))])])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-main-area col-md-3"
  }, [(_vm.temp_card_list.loading != true) ? _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": function($event) {
        _vm.addNewCardList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 增加更多事項\n                  ")]) : _c('button', {
    staticClass: "btn btn-default btn-block disable"
  }, [_c('i', {
    staticClass: "fas fa-spinner"
  }), _vm._v(" 事項分類建立中..")]), _vm._v(" "), (_vm.temp_card.project_card_lists.length == 0 && _vm.temp_card.project_card_comments.length == 0) ? _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": function($event) {
        _vm.deleteProjectCard()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" 刪除卡片")]) : _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": function($event) {
        _vm.temp_card.delete_alert = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" 刪除卡片")]), _vm._v(" "), (_vm.temp_card.delete_alert == true) ? _c('div', [_c('p', {
    staticClass: "mt-3"
  }, [_vm._v("你確定要刪除這個卡片？這個動作將會同時刪除卡片內的所有分類、項目、與資料")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.deleteProjectCard()
      }
    }
  }, [_vm._v("確認刪除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.temp_card.delete_alert = false
      }
    }
  }, [_vm._v("取消")])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showOwnersModal) ? _c('div', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showOwnersModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.showOwnersModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "min-height": "0px"
    }
  }, [_c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showOwnersModal = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body row j-forms",
    staticStyle: {
      "padding": "0 0 10px 0",
      "max-height": "85vh"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("參與的人員")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._l((_vm.temp_list.owners), function(user) {
    return _c('div', {
      staticClass: "p-3 pointer",
      on: {
        "click": function($event) {
          _vm.removeOnwer(user)
        }
      }
    }, [_c('div', {
      staticClass: "media"
    }, [_c('img', {
      staticClass: "img-thumbnail img-circle avatar-size avatar-size-md",
      attrs: {
        "src": user.avatar || '/static/avatar-default.jpg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "media-body align-self-center"
    }, [_c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _vm._m(4, true)])])])
  }), _vm._v(" "), (_vm.temp_list.owners.length == 0) ? _c('div', {
    staticClass: "py-5 px-3 text-center"
  }, [_vm._v("目前無負責人員，請點擊右側清單即可增加")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("公司人員")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_keyword),
      expression: "user_keyword"
    }],
    staticClass: "form-control mb-2",
    attrs: {
      "placeholder": "輸入姓名過濾"
    },
    domProps: {
      "value": (_vm.user_keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterCompanyUsers.length > 0) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, _vm._l((_vm.filterCompanyUsers), function(user) {
    return _c('div', {
      staticClass: "p-3 pointer",
      on: {
        "click": function($event) {
          _vm.addOwner(user)
        }
      }
    }, [_c('div', {
      staticClass: "media"
    }, [_c('img', {
      staticClass: "img-thumbnail img-circle avatar-size avatar-size-md",
      attrs: {
        "src": user.avatar || '/static/avatar-default.jpg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "media-body align-self-center"
    }, [_c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _vm._m(5, true)])])])
  }))]) : _c('div', {
    staticClass: "py-5 px-3 text-center"
  }, [_vm._v("無成員")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showDateChooseModal) ? _c('div', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showDateChooseModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.showDateChooseModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-7",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "min-height": "0px"
    }
  }, [_c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showDateChooseModal = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body row modal-calendar",
    staticStyle: {
      "padding": "0 0 10px 0",
      "max-height": "85vh"
    }
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("選擇工作日期")]), _vm._v(" "), _c('date-range-picker', {
    ref: "picker",
    attrs: {
      "opens": "inline",
      "locale-data": _vm.dateRangeOption,
      "showWeekNumbers": false,
      "show-dropdowns": true,
      "autoApply": true,
      "linkedCalendars": true,
      "ranges": _vm.range
    },
    on: {
      "update": _vm.updateDatepicker
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), (_vm.temp_list.start_at && _vm.temp_list.end_at) ? _c('p', {
    staticClass: "p-5 text-center"
  }, [_vm._v(_vm._s(_vm._f("moment_date")(_vm.temp_list.start_at, "")) + " ~ " + _vm._s(_vm._f("moment_date")(_vm.temp_list.end_at, "")) + " "), _c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": function($event) {
        _vm.removeDateTime()
      }
    }
  })]) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.temp_list.delete_alert == true) ? _c('div', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.temp_list.delete_at = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.temp_list.delete_at = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-7",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "min-height": "0px"
    }
  }, [_c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.temp_list.delete_at = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body row modal-calendar",
    staticStyle: {
      "padding": "0 0 10px 0",
      "max-height": "85vh"
    }
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("你確定刪除『" + _vm._s(_vm.temp_list.name) + "』嗎？")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("這個動作將會刪除此列表以及他所有的卡片")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.deleteProjectList(_vm.temp_list)
      }
    }
  }, [_vm._v("確定刪除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.resetTempList()
      }
    }
  }, [_vm._v("取消")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showSaveTemplateModal) ? _c('div', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showSaveTemplateModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.showSaveTemplateModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-7",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "min-height": "0px"
    }
  }, [_c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showSaveTemplateModal = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body row",
    staticStyle: {
      "padding": "0 0 10px 0",
      "max-height": "85vh"
    }
  }, [_c('div', {
    staticClass: "col-md-12 text-center jutify-content-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 align-self-center"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_template.name),
      expression: "temp_template.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "新範本名稱"
    },
    domProps: {
      "value": (_vm.temp_template.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_template.name = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.temp_template.loading == false) ? _c('button', {
    staticClass: "btn btn-primary ml-3",
    on: {
      "click": function($event) {
        _vm.saveProjectTemplate()
      }
    }
  }, [_vm._v("儲存為新範本")]) : _c('button', {
    staticClass: "btn btn-primary ml-3 disabel"
  }, [_vm._v("儲存中...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.project_templates.length == 0) ? _c('p', {
    staticClass: "alert alert-info"
  }, [_vm._v("你目前沒有範本，請從上方輸入範本名稱，flowneat會將這個專案的工作列表儲存為新範本")]) : _c('div', {
    staticClass: "template-modal-content"
  }, _vm._l((_vm.project_templates), function(template) {
    return _c('div', {
      staticClass: "card p-2 mb-3"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-5 text-left pointer"
    }, [(_vm.canEditColumn('template_name', template.id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (template.name),
        expression: "template.name"
      }],
      ref: ('template_name' + template.id),
      refInFor: true,
      staticClass: "form-control",
      domProps: {
        "value": (template.name)
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.target.blur()
        },
        "blur": function($event) {
          _vm.updateTemplate(template, 'name')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          template.name = $event.target.value
        }
      }
    }) : _c('div', {
      on: {
        "click": function($event) {
          _vm.editColumn('template_name', template.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil-alt"
    }), _vm._v(" " + _vm._s(template.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5 text-left"
    }, [(template.project_lists_amount != 0) ? _c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t列表：" + _vm._s(template.project_lists_amount) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (template.project_cards_amount != 0) ? _c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t卡片：" + _vm._s(template.project_cards_amount) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (template.project_card_list_items_amount != 0) ? _c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t項目：" + _vm._s(template.project_card_list_items_amount) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (template.work_days != 0) ? _c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t總工作天：" + _vm._s(template.work_days) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 text-right"
    }, [(template.save_alert == false) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      on: {
        "click": function($event) {
          template.save_alert = true
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-save"
    })]) : _vm._e(), _vm._v(" "), (template.delete_alert == false) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      on: {
        "click": function($event) {
          template.delete_alert = true
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash"
    })]) : _vm._e()]), _vm._v(" "), (template.save_alert == true) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('p', {
      staticClass: "mt-2"
    }, [_vm._v(" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t你確定將『" + _vm._s(_vm.deal.deal_title) + "』的工作項目覆蓋於『範本-" + _vm._s(template.name) + "』嗎?\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.updateTemplate(template, 'template')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-save"
    }), _vm._v(" 確定")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          template.save_alert = false
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" 取消")])])]) : _vm._e(), _vm._v(" "), (template.delete_alert == true) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('p', {
      staticClass: "mt-2"
    }, [_vm._v(" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t你確定將『範本-" + _vm._s(template.name) + "』刪除嗎?\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.deleteTemplate(template)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash"
    }), _vm._v(" 確定刪除")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          template.delete_alert = false
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" 取消")])])]) : _vm._e()])])])
  }))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showImportTemplateModal) ? _c('div', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showImportTemplateModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.showImportTemplateModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-7",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "min-height": "0px"
    }
  }, [_c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.showImportTemplateModal = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body row",
    staticStyle: {
      "padding": "0 0 10px 0",
      "max-height": "85vh"
    }
  }, [_c('div', {
    staticClass: "col-md-12 text-center jutify-content-center"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 align-self-center"
  }, [_c('h4', {
    staticClass: "text-center bold"
  }, [_vm._v("匯入工作範本")]), _vm._v(" "), _c('p', [_vm._v("輕輕一點，輕鬆建立工作項目，大幅降低你的規劃時間 :)")]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "align-self-center mr-3"
  }, [_vm._v("工作起始日期")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "format": _vm.customFormatter,
      "language": "zh"
    },
    model: {
      value: (_vm.template_start_date),
      callback: function($$v) {
        _vm.template_start_date = $$v
      },
      expression: "template_start_date"
    }
  })], 1)]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 align-self-center"
  }, [(_vm.project_templates.length == 0) ? _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t您目前沒有範本，請先點擊以下按鈕建立範本\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('button', {
    staticClass: "btn btn-default text-left",
    on: {
      "click": function($event) {
        _vm.resetTempTemplate();
        _vm.showImportTemplateModal = false;
        _vm.showSaveTemplateModal = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" 儲存新範本")])]) : _c('div', {
    staticClass: "template-modal-content row"
  }, _vm._l((_vm.project_templates), function(template) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "card p-2 mb-3"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('h4', [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t列表：" + _vm._s(template.project_lists_amount) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t卡片：" + _vm._s(template.project_cards_amount) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t項目：" + _vm._s(template.project_card_list_items_amount) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), (template.work_days != 0) ? _c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t總工作天：" + _vm._s(template.work_days) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', [(template.loading == false && template.import_alert == false) ? _c('button', {
      staticClass: "btn btn-default btn-xs",
      on: {
        "click": function($event) {
          template.import_alert = true
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-file-import"
    }), _vm._v(" 匯入\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (template.import_alert == true) ? _c('div', {
      staticClass: "alert alert-info"
    }, [_c('p', {
      staticClass: "mt-3"
    }, [_vm._v("匯入新範本將會取代此專案的所有工作項目")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          template.import_alert = false;
          _vm.importTemplate(template)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-file-import"
    }), _vm._v(" 確定匯入\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs",
      on: {
        "click": function($event) {
          template.import_alert = false
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-file-import"
    }), _vm._v(" 取消\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (template.loading == true) ? _c('button', {
      staticClass: "btn btn-default btn-xs disable"
    }, [_vm._v("匯入中..")]) : _vm._e()])])])])
  }))])])])])])])])]) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "project_control_container"
  }, [(_vm.list_loading) ? _c('button', {
    staticClass: "btn btn-default btn-block disable text-left"
  }, [_vm._m(7)]) : _c('button', {
    staticClass: "btn btn-default text-left btn-block",
    on: {
      "click": function($event) {
        _vm.addNewList()
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default text-left btn-block",
    on: {
      "click": function($event) {
        _vm.resetTempTemplate();
        _vm.showSaveTemplateModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" 儲存為範本")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default text-left btn-block",
    on: {
      "click": function($event) {
        _vm.showImportTemplateModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-file-import"
  }), _vm._v(" 從範本匯入")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 列表建立中")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增列表")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "bold500"
  }, [_c('i', {
    staticClass: "fas fa-align-justify"
  }), _vm._v(" 描述")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("指派此項目的負責人")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 text-left align-self-center"
  }, [_c('h4', {
    staticClass: "text-center bold"
  }, [_vm._v("儲存為工作範本")]), _vm._v(" "), _c('p', [_vm._v("工作範本是flowneat裡面獨特且強大的功能之一")]), _vm._v(" "), _c('p', [_vm._v("你可以將一個常態性的工作流程仔細規劃之後，將此工作流程儲存為範本SOP，flowneat範本會紀錄工作項目、工作天數")]), _vm._v(" "), _c('p', [_vm._v("當你未來遇到同樣類型的工作，直接匯入範本，將可以大幅降低規劃所需的時間！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 列表建立中")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增列表")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d3d2565","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManage/ProjectManageBoard.vue
// module id = 698
// module chunks = 4